export const BYOD_AMPLITUDE_EVENTS = {
  CUSTOM_DASHBOARD_SAVED: 'Custom Dashboard Saved',
  CUSTOM_DASHBOARD_CREATED: 'Custom Dashboard Created',
  CUSTOM_DASHBOARD_DELETED: 'Custom Dashboard Deleted',
  CUSTOM_DASHBOARD_EDITED: 'Custom Dashboard Edited',
  REPORT_ADDED_TO_DASHBOARD: 'Report Added to Dashboard',
  REPORT_REMOVED_FROM_DASHBOARD: 'Report Removed from Dashboard',
  REPORT_CONFIG_EDITED: 'Report Config Edited',
  SCOUT_VISITED: 'Scout Visited',
  DASHBOARD_PINNED_TO_HOME: 'Dashboard Pinned to Home',
  REPORTS_LIBRARY_VISITED: 'Reports Library Visited',
  REPORT_VIEWED: 'Report Viewed',
  DASHBOARD_LAYOUT_CHANGED: 'Dashboard Layout Changed',
  DASHBOARD_DATE_RANGE_CHANGED: 'Dashboard Date Range Changed',
  REPORT_FILTERS_APPLIED: 'Report Filters Applied',
  CHART_STYLE_CHANGED: 'Chart Style Changed',
  KPI_SEMANTIC_CHANGED: 'KPI Semantic Changed',
  DASHBOARD_SECTION_ADDED: 'Dashboard Section Added',
  UNSAVED_CHANGES_EXITED: 'Unsaved Changes Exited',
  CUSTOM_DASHBOARD_UPDATED: 'Custom Dashboard Updated',
  REPORT_EXPORTED: 'Report Exported',
} as const;
